import isFinite from 'lodash/isFinite';

export default class FormatUtils {
    static formatDuration(duration, options = {}) {
        if (!isFinite(duration)) return '';
        const defaultOptions = { excludeSeconds: false, format: 'long' };
        options = { ...defaultOptions, ...options };
        let remainingDuration = duration;
        const units = [
            {
                name: 'hour',
                inSeconds: 60 * 60,
                formats: {
                    long: ' hour',
                    short: 'hr'
                }
            },
            {
                name: 'minute',
                inSeconds: 60,
                formats: {
                    long: ' minute',
                    short: 'min'
                }
            },
            {
                name: 'second',
                inSeconds: 1,
                formats: {
                    long: ' second',
                    short: 'sec'
                }
            }
        ];
        const parts = units.map(unit => {
            if (options.excludeSeconds && unit.name === 'second') return '';
            const value = Math.floor(remainingDuration / unit.inSeconds);
            remainingDuration = remainingDuration % unit.inSeconds;
            if (value === 0 && remainingDuration > 0) return '';
            return value;
        });

        const [hours, minutes] = parts;

        return {
            hours,
            minutes
        };
    }

    static truncate(text, options = {}) {
        const defaultOptions = {
            length: 50,
            separator: ' ',
            omission: '...',
            splitWords: false
        };
        options = { ...defaultOptions, ...options };
        if (!text || text.length < options.length) return text;
        text = text.substr(0, options.length - options.omission.length);
        if (options.splitWords === false) {
            const truncateAt = text.lastIndexOf(options.separator);
            text = text.substr(0, truncateAt);
        }
        return text + options.omission;
    }

    static toTitleCase(str) {
        return str.replace(/\w\S*/g, txt => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
}
